<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-pagos-universidades"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :pinnedBottomRowData="pinnedBottomRowData">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro, formatearValorAMoneda, valueFormatterMoneda } from '../utils/funciones';

export default {
  name: 'ListadoPagosUniversidades',
  mixins: [listadoAgGridMixin],
  computed: {
    pinnedBottomRowData() {
      return [
        {
          nombreDepositante: 'Total',
          totalEstudiantes: this.items.reduce((acc, item) => acc + item.detallesPagosUniversidades?.length, 0),
          montoDeposito: formatearValorAMoneda(
            this.items
              .reduce((acc, item) => {
                return acc + Number(item.solicitudPago?.monto) * item.detallesPagosUniversidades?.length;
              }, 0)
              .toFixed(2),
          ),
        },
      ];
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'N° COMPROBANTE',
          field: 'numeroComprobante',
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'NOMBRE DEPOSITANTE',
          field: 'nombreDepositante',
          minWidth: 300,
        },
        {
          headerName: 'N° ESTUDIANTES',
          cellRenderer: (params) => {
            if (!params.node.rowPinned) {
              const cantidadEstudiantes = params.data?.detallesPagosUniversidades?.length || 0;

              return cantidadEstudiantes;
            }

            return params.data?.totalEstudiantes;
          },
          type: 'numericColumn',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'MONTO DEPOSITO',
          field: 'montoDeposito',
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              return (params.data?.solicitudPago?.monto * params.data?.detallesPagosUniversidades?.length).toFixed(2);
            }

            return params.data?.montoDeposito;
          },
          type: 'numericColumn',
          valueFormatter: valueFormatterMoneda,
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'FECHA DEPOSITO',
          field: 'fechaDeposito',
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'ELIMINADO EN',
          field: 'eliminadoEn',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-pagos-universidades {
  height: calc(var(--vh, 1vh) * 100 - 23.5rem);
}
</style>
  